import { Checkbox } from 'antd';

import { BaseFormFieldWrapper } from '../BaseFormFieldWrapper/BaseFormFieldWrapper';

import './BaseCheckbox.scss';

const BaseCheckbox_ = (props) => {
  const { field, onBlur, children, handleChange, ...rest } = props;

  return (
    <>
      <Checkbox {...field} {...rest} onBlur={onBlur} onChange={(e) => handleChange(e.target.checked)}>
        {children && <span className="checkbox-text">{children}</span>}
      </Checkbox>
    </>
  );
};

export const BaseCheckbox = BaseFormFieldWrapper(BaseCheckbox_);
export default BaseCheckbox;
